import { useSelector } from 'react-redux';

import type { RootState } from '../../../../store';

export default function useDocumentDetailsLoading() {
  return useSelector(
    (state: RootState) => state.onboardingQuestionnaire.documentDetailsLoading,
  );
}
